<template>
  <base-type-form :propPageID="pageID" :propFromRoute="fromRoute" />
</template>

<script>
    import mixin from '../../../../mixin';
    import BaseTypeForm from '../../../../components/type/Form.vue';

    export default {
        components: {
            BaseTypeForm
        },
        mixins: [
            mixin,
        ],
        data() {
            return {
                pageID: 'municipal_interventions_global_types',
            }
        },
    }
</script>
